/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Avatar,
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Typography,
  Button,
} from "@mui/material";
import classNames from "classnames";
import styles from "./../sass/assets.module.scss";
import { useSelector } from "react-redux";
import { ArrowLeft } from "mdi-material-ui";

const Assets = (props) => {
  const { loggedin, loading } = useSelector((state) => state.app);
  const assets = useSelector((state) => state.assets);
  const balance = useSelector((state) => state.balance);
  
  const showUserBalance = (asset) => {
    const findAsset = balance.list.find((item) => {
      if(item.asset && asset.symbol === item.asset.symbol) {
        return item;
      }
    });
    return (
      <TableCell align="right">
        <div className={classNames(styles["price"])}>
          <Typography
            variant="body2"
            className={classNames(styles["value"])}
          >
            {
              findAsset ? findAsset.amount : 0
            }
          </Typography>
          <Typography
            variant="caption"
            className={classNames(styles["movement"])}
          >
            {
              findAsset ? (
                (findAsset.amount * asset?.bid).toLocaleString(
                  "en-US",
                  {
                    style: "currency",
                    currency: "USD",
                  }
                )
              ) : "$0.00"
            }
          </Typography>
        </div>
      </TableCell>
    )
  }
 
  return (
    <>
      {props.id && (
        <Button
          startIcon={<ArrowLeft />}
          size="small"
          variant="outlined"
          className="mb-3"
          onClick={() => {
            props.history.push("/app");
          }}
        >
          Back
        </Button>
      )}
      <TableContainer component={Paper} elevation={0} className={classNames(styles["assets"])}>
        <Table sx={{ minWidth: 650 }} aria-label="Assets Table">
          <TableHead>
            <TableRow>
              <TableCell>Asset</TableCell>
              <TableCell align="left">Bid</TableCell>
              <TableCell align="left">Ask</TableCell>
              {(loggedin && !loading && !balance.loading) && <TableCell align="right">Your Balance</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {assets.loading && (
              <TableRow>
                <TableCell colSpan={(loggedin && !loading && !balance.loading) ? 4 : 3}>
                  <LinearProgress color="success" />
                </TableCell>
              </TableRow>
            )}

            {!assets.loading && assets.list.length > 0 && (
              <>
                {assets.list.map((asset, i) => {
                  if ((props.id && props.id !== asset.id) || asset.symbol === "tether") {
                    return null;
                  }
                  return (
                    <TableRow
                      key={i}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        cursor: asset.trade && "pointer",
                      }}
                      hover={true}
                      onClick={() => {
                        if (!asset.trade) return;
                        props.history.push("/asset/" + asset.id);
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                      >
                        <div className="d-flex align-items-center">
                          <Avatar
                            className="me-3"
                            alt={`${asset.name}'s Logo`}
                            src={
                              asset.logo 
                              ? 
                              asset.logo.formats?.thumbnail ? asset.logo.formats?.thumbnail?.url : asset.logo.url
                              : 
                              ""
                            }
                          />
                          <Box>
                            <Typography variant="body2">
                              {asset.name}
                            </Typography>
                            <Typography variant="caption" className="d-block">
                              {asset.display_symbol}
                            </Typography>
                          </Box>
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        {asset.bid && (
                          <div className={classNames(styles["price"])}>
                            <Typography
                              variant="body2"
                              className={classNames(styles["value"])}
                            >
                              ${asset.bid.toFixed(2)}
                            </Typography>
                          </div>
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {asset.ask && (
                          <div className={classNames(styles["price"])}>
                            <Typography
                              variant="body2"
                              className={classNames(styles["value"])}
                            >
                              ${asset.ask.toFixed(2)}
                            </Typography>
                          </div>
                        )}
                      </TableCell>
                      {
                        (loggedin && !loading && !balance.loading) && (
                          showUserBalance(asset)
                        )
                      }
                    </TableRow>
                  );
                })}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Assets;
